// Autogenerated file
export const tripSheetMedicalInspectionResultsEnum = {
    NotCompleted: "NotCompleted",
    Admitted: "Admitted",
    NotAdmitted: "NotAdmitted",
    NotSpecified: "NotSpecified",
};
export const tripSheetMedicalInspectionResults = [
    { label: "Осмотр не завершён", value: "NotCompleted" },
    { label: "Допущен", value: "Admitted" },
    { label: "Не допущен", value: "NotAdmitted" },
    { label: "Не указан", value: "NotSpecified" },
];
